export default __webpack_public_path__ + "static/media/video.697d9c04.mp4";